import { CountryCodeType } from '$/store/useOfficialStore/types';

/**
 * 判断是否为海外
 * @param currentCountryCode 国家代码
 * @returns 是否为海外
 */
export function getIsOverseaByCountryCode(currentCountryCode: CountryCodeType) {
  const mainlandCode = ['CN', 'TW', 'HK', 'MO'];
  return !mainlandCode.includes(currentCountryCode);
}
